import * as React from 'react';
import { useFormikContext } from 'formik';

import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureStepLibraryForm from '../EventProcedureStepLibraryForm';

type Props = {
  onClose: () => void;
};

function StepLibraryFormik({ onClose }: Props) {
  const {
    values: { steps },
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<EventProceduresAPIType<Array<EventProcedureStepAPIType>>>();

  const handleAddSteps = React.useCallback(
    (newSteps: Array<EventProcedureStepAPIType>) => {
      setFieldValue('steps', newSteps);
      setFieldTouched('steps', true);
      onClose();
    },
    [setFieldTouched, setFieldValue, onClose],
  );

  return <EventProcedureStepLibraryForm selectedSteps={steps} onClose={onClose} onAdd={handleAddSteps} />;
}

export default StepLibraryFormik;
